export type FormFields = {
    anthropicProperties: AnthropicPropertiesFields;
    advancedSettings: AdvancedSettingsFields;
    promts: PromtsFields;
    actions: {
        callingClassificationInstruction: string;
    }
}

export enum SectionName {
    AnthropicProperties = 'anthropicProperties',
    AdvancedSettings = 'advancedSettings',
    Promts = 'promts'
}

export type AnthropicPropertiesFields = {
    enabled: boolean;
    apiKey: string;
}

export type AdvancedSettingsFields = {
    historyLimit?: number;
    messagesParams: {
        model: string;
        max_tokens?: number;
    }
}

export type PromtsFields = {
    knowledgeBase: string;
    botInstruction: string;
}
